import { gql } from '@apollo/client'

export const GET_BENEFIT_EVENTS_LIST = gql`
  query GetBenefitEvents {
    benefitEvents {
      total
      size
      items {
        eventId
        tag
        name
        region
        eventDate
        redeem {
          end
          start
        }
        quantity
        quantityAvailable
        benefit {
          id
          cost
        }
        status
        businessUnit
        multipleDates
        startTime
        endTime
      }
    }
  }
`
